import { NgModule, inject, provideAppInitializer } from "@angular/core";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { environment } from "../environments/environment";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { TenantDetailComponent } from "./tenant-detail/tenant-detail.component";
import { TenantSolutionsComponent } from "./tenant-solutions/tenant-solutions.component";
import { TenantEntitlementsComponent } from "./tenant-entitlements/tenant-entitlements.component";
import { TenantUsersComponent } from "./tenant-users/tenant-users.component";
import { UsersComponent } from "./users/users.component";
import { SkusComponent } from "./skus/skus.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatCardModule } from "@angular/material/card";
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TenantsComponent } from "./tenants/tenants.component";
import { MatProgressBar, MatProgressBarModule } from "@angular/material/progress-bar";
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from "ng2-charts";
import { NgCircleProgressModule } from "ng-circle-progress";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { DsioUiLibraryModule } from "@kelyn-technologies/dsio-angular-lib";
import { SkusDetailComponent } from "./skus/sku-detail/skus-detail.component";
import { AuthorizationsComponent } from "./authorizations/authorizations.component";
import { OPERATIONS_BASE_PATH } from "./tenant-operations/tenant-operations.service";
import {
  ApiModule,
  BASE_PATH,
  Configuration,
} from "@kelyn-technologies/dsio-angular-lib/dsio-api";

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        realm: "datastorio_controlplane",
        url: `${environment.KEYCLOAK_URL}`,
        clientId: "websiteclient",
      },
      initOptions: {
        onLoad: "login-required",
        silentCheckSsoRedirectUri:
          window.location.origin + "/assets/silent-check-sso.html",
      },
      enableBearerInterceptor: true,
      bearerExcludedUrls: ["/assets"],
      shouldUpdateToken: (request) => {
        return !(request.headers.get("token-update") === "false");
      },
    });
}

export function apiConfiguration(): Configuration {
  const tenantId = sessionStorage.getItem("tenantId") as string;
  return new Configuration({
    credentials: {
      dsioTenantId: "datastorio_controlplane",
    },
  });
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    DsioUiLibraryModule,
    SkusDetailComponent,
    TenantsComponent,
    TenantUsersComponent,
    TenantEntitlementsComponent,
    SkusComponent,
    TenantDetailComponent,
    TenantSolutionsComponent,
    AuthorizationsComponent,
    UsersComponent,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    KeycloakAngularModule,
    BaseChartDirective,
    MatDialogModule,
    MatProgressBarModule,
    MatProgressBar,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "transparent",
      animationDuration: 300,
      showBackground: true,
      backgroundStrokeWidth: 16,
      backgroundStroke: "#F2F2F2",
      backgroundPadding: -8,
    }),
    ApiModule.forRoot(apiConfiguration),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(() => {
        const initializerFn = (initializeKeycloak)(inject(KeycloakService));
        return initializerFn();
      }),
    provideAnimations(),
    {
      provide: MatDialogRef,
      useValue: {},
    },
    provideCharts(withDefaultRegisterables()),
    { provide: BASE_PATH, useValue: environment.API_URL },
    { provide: OPERATIONS_BASE_PATH, useValue: environment.OPERATIONS_API_URL },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
